import React from "react";
import { Mui } from "../../libraries/material";

const Grief = Mui.createSvgIcon(
  <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g
      id="Artboard"
      transform="translate(-686.000000, -38.000000)"
      fillRule="nonzero"
    >
      <g id="grief" transform="translate(686.000000, 38.000000)">
        <path
          d="M14.3653527,0 C17.9339685,0 20.8268919,2.89292342 20.8268919,6.46153923 L20.8268919,8.61538564 L19.9038135,8.61538564 L19.9038135,6.46153923 L19.9022149,6.32698537 C19.8670149,4.85101596 19.2544302,3.51803119 18.2816301,2.54526184 C17.2793838,1.5429848 15.8947683,0.923077033 14.3653527,0.923077033 C12.8359679,0.923077033 11.4513524,1.5429848 10.4490753,2.54526184 C9.47627519,3.51803119 8.86369051,4.85101596 8.8284905,6.32698537 L8.8268905,6.46153923 L8.8268905,20.9230794 L7.90381347,20.9230794 L7.90381347,6.46153923 C7.90381347,2.89292342 10.7967369,0 14.3653527,0 Z"
          id="Path"
          fill="currentColor"
          fillOpacity="0.6"
        ></path>
        <path
          d="M8.2708289,21.9230794 C13.0368295,21.9230794 16.9046145,16.5648326 16.9230761,14.2307708 C11.1163677,14.2300323 8.73836741,19.1462114 8.27501351,19.1647375 C7.81165961,19.1832668 5.68205936,14.2893862 4.72098475e-06,14.28914 C-0.0046982414,16.5488634 3.5048591,21.9230794 8.2708289,21.9230794 Z M23.999999,7.32812383 L23.999999,11.1836012 C23.999999,11.6050474 23.9268308,12.0094167 23.7924615,12.3846167 C23.7373846,12.3841244 23.6864923,12.3551706 23.6579077,12.3081244 L22.0740921,9.70070873 L22.0740921,9.70070873 L20.5988611,12.1169859 C20.5029534,12.2740629 20.3321842,12.3698783 20.1481534,12.3698783 C19.9641226,12.3698783 19.7933533,12.2740629 19.6974764,12.1169859 L18.2222455,9.70070873 L18.2222455,9.70070873 L16.7933838,12.0410167 C16.6679684,12.2464321 16.4480606,12.3754167 16.2075683,12.3846167 L16.2075683,12.3846167 L16.2075683,12.3846167 C16.0731991,12.0094167 15.999999,11.6050474 15.999999,11.1836012 L15.999999,7.32812383 C15.999999,5.3626159 17.5918762,3.7692311 19.5555687,3.7692311 L20.4444611,3.7692311 C22.4081229,3.7692311 23.999999,5.3626159 23.999999,7.32812383 Z"
          id="Shape"
          fill="currentColor"
        ></path>
      </g>
    </g>
  </g>,
  "grief and loss"
);

export default Grief;
